// extracted by css-extract-rspack-plugin
export default {"cls1":"ClaimDetails-cls1_RMi","cls2":"ClaimDetails-cls2_tEd ClaimDetails-cls1_RMi"};